import { requestGQL } from 'common/graphQlClient';
import { gql } from 'graphql-request';

export const PATCH_BUNDLE = gql`
  mutation patchBundle($input: BundleInput!) {
    patchBundle(input: $input)
  }
`;

export const patchBundle = (propertyId: number) => (bundleDetails: any) => {
  return requestGQL(PATCH_BUNDLE, { input: { propertyId, bundleDetails } });
};
